export function getOptions(phpFile) {

    return function(dispatch) {

        fetch(phpFile)
            .then(response => response.json())
            .then(data => {
                dispatch({
                    type: "OPTIONS",
                    payload: data
                })
            })
            .catch((error) => {
                dispatch({
                    type: "OPTIONS",
                    payload: error
                })
            })
    }
};


// WEBPACK FOOTER //
// ./src/actionCreators/getOptions.js